import { HeaderWcp } from '@intigral/ui';
import { Link } from 'react-router-dom';
import OverlaySearchContainer from '../../../components/elements/search/OverlaySearchContainer';
import user from '../../../helpers/user';
import { closeSearchInputOverlay } from '../../../store/reducers/headerSlice';
import { verifyPasswordOnSwitch } from '../../../store/reducers/profileSlice';
import { __ } from '../../../translations';
import ConfirmPopup from '../../../components/elements/ConfirmPopup';
import PasswordPopup from '../../../components/elements/PasswordPopup';
import SelectProfileLoader from '../../../components/elements/SelectProfileLoader';
import { HeadermenuItem } from './HeaderMenuItem';
import { Breadcrumb, MobileItem, StaticItem } from './elements';
import { useHeaderActions } from '../hooks/useHeaderActions';

const Header = () => {
    const B2B_localization = user.getUserSegment() === 'B2B' ? 'b2b_' : '';
    const {
        selectedProfile,
        currentProviderLink,
        isMobile,
        navItems,
        searching,
        searchQuery,
        searchError,
        showPasswordPopup,
        clickedProfile,
        loadingProfile,
        showConfirmPopup,
        searchInputRef,
        dispatch,
        setClickedProfile,
        setSearchQuery,
        setPasswordVerified,
        setLoadingProfile,
        menuRef,
        handleSearchFormSubmit,
        closePasswordPopupHandler,
    } = useHeaderActions();

    return (
        <>
            <HeaderWcp
                ref={menuRef}
                logoProps={{
                    homeUrl: !selectedProfile?.kidsMode ? '/' : 'kids-home',
                    title: 'STC logo',
                    logoSrc: 'images/big-logo.svg',
                    LinkComponent: Link,
                }}
                menuProps={
                    currentProviderLink && !isMobile ? (
                        <Breadcrumb currentProviderLink={currentProviderLink} />
                    ) : (
                        {
                            nav: navItems,
                        }
                    )
                }
                staticChildren={<StaticItem />}
                mobileChildren={<MobileItem />}
            >
                <HeadermenuItem setClickedProfile={setClickedProfile} />
            </HeaderWcp>

            {searching && (
                <OverlaySearchContainer
                    open={searching}
                    ref={searchInputRef}
                    query={searchQuery}
                    setQuery={setSearchQuery}
                    onOpenChange={() => dispatch(closeSearchInputOverlay(false))}
                    handleSearchFormSubmit={handleSearchFormSubmit}
                    searchError={searchError}
                />
            )}
            <PasswordPopup
                description={__(B2B_localization + 'password_popup_description_selectProfile')}
                showPopup={showPasswordPopup}
                onSuccess={() => setPasswordVerified(true)}
                onClose={() => closePasswordPopupHandler()}
                profile={clickedProfile ? clickedProfile : {}}
                verifyPasswordFunction={verifyPasswordOnSwitch}
                showForgotPassword={!clickedProfile?.passwordProtected}
            />
            <SelectProfileLoader
                loadingProfile={loadingProfile}
                autoCloseLoading={2000}
                onClose={() => setLoadingProfile(false)}
            />
            <ConfirmPopup
                showPopup={showConfirmPopup}
                popupAction={false}
                autoRedirect
                title={null}
                description={__('manage_profile_your_profile_deleted')}
            />
        </>
    );
};

export default Header;
